// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"c42b0b02","352":"6162a58d","634":"939f8a98","874":"f5bbe1c9","875":"46ced1c2","880":"377c4a03"}[chunkId] + ".chunk.js";
};